module.exports = __webpack_public_path__ + "34bc775d/img/menu-icon.5f8facae.svg";